import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { isAllowEdit } from 'features/supplier/utils';

import { toastError, toastSuccess } from '@components/Toast';

import { fetchSupplierDetails } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import { getShortName, isValidEmail, isValidURL, validateNumber } from '@utils/Util';

const Contact = ({ data, webAddress, supplierId, isAdd, onSetAdd }) => {
	const [contactInfo, setContactInfo] = useState([]);
	const [webSite, setWebSite] = useState('');
	const [, setIsLoading] = useState(false);
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);
	const [isShow, setIsShow] = useState(isAdd);
	const [viewType, setViewType] = useState('');
	const [showEditWeb, setShowEditWeb] = useState(false);
	const [errors, setErrors] = useState({});

	const dispatch = useDispatch();

	useEffect(() => {
		setContactInfo(data);
		setWebSite(webAddress);
	}, [data, webAddress]);

	useEffect(() => {
		setViewType('add');
		setIsShow(isAdd);
	}, [isAdd]);

	const handleClose = () => {
		dispatch(fetchSupplierDetails(supplierId));
		setIsShow(false);
		onSetAdd(false);
		setIsSubmitLoading(false);
		setShowEditWeb(false);
		setSelectedItem(null);
		setErrors({});
	};
	const onEditContact = (item) => {
		setIsShow(true);
		setSelectedItem(item);
		setViewType('edit');
	};

	const onContactChange = (e) => {
		const name = e.target.name;
		setSelectedItem({ ...selectedItem, [name]: e.target.value });
	};

	const updateContact = async () => {
		await ApiClient.PUT('updateContactPerson', selectedItem, selectedItem.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const addContact = async () => {
		await ApiClient.POST('addContactPerson', selectedItem, supplierId)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const isValid = () => {
		if (!selectedItem?.name) {
			setErrors({ ...errors, nameError: 'Name is required' });
			return true;
		}

		if (!selectedItem?.phone) {
			setErrors({ ...errors, phoneError: 'Phone is required' });
			return true;
		}

		if (selectedItem.email && !isValidEmail(selectedItem.email)) {
			setErrors({ ...errors, emailError: 'Valid email is required' });
			return true;
		}

		return false;
	};

	const removeContactPerson = async (id) => {
		await ApiClient.DELETE('removeContactPerson', {}, id)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onSave = () => {
		setIsSubmitLoading(true);

		let error = isValid();
		if (error) {
			setIsSubmitLoading(false);
			return;
		}

		if (viewType === 'add') {
			addContact();
		}
		if (viewType === 'edit') {
			updateContact();
		}
	};

	const onEditWebsite = () => {
		setShowEditWeb(true);
	};

	const onSubmitWeb = async () => {
		setIsSubmitLoading(true);
		if (webSite && !isValidURL(webSite)) {
			setErrors({ ...errors, webUrlError: 'Valid web address is required' });

			return false;
		}
		await ApiClient.PUT('updateSupplierInfo', { website: webSite }, supplierId)
			.then(({ data }) => {
				setIsSubmitLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsSubmitLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<>
			<div className="row">
				{contactInfo?.map((item) => (
					<div className="col-md-6 padding-col" key={item?.id}>
						<div className="location-details contact-details pb-0">
							<div className="location-heading">
								<span className="regular-16 gray_dark_01 weight-600">
									{item.name} ({item?.designation})
								</span>
								{isAllowEdit() && (
									<img
										src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
										alt="edit"
										onClick={() => onEditContact(item)}
									/>
								)}
							</div>
							<div className="full-details ">
								<div className="info-details d-flex">
									<p className="regular-14 gray_dark_02">{item.phone}</p>
								</div>
							</div>
						</div>
					</div>
				))}
				<div className="col-md-12 padding-col">
					<div className="info-details mb-2 d-flex align-items-center">
						<p className="regular-14 gray_dark_02">Website</p>
						<p className="gray_dark_02">:</p>
						<p className="regular-14 map-link d-flex align-items-center ml-2">
							<a href={webAddress} target="_blank" rel="noreferrer" className="gray_dark_01">
								{getShortName(webAddress)}
							</a>
							{isAllowEdit() && (
								<img
									width="20px"
									src={`${process.env.PUBLIC_URL}/icons/edit-supplier.svg`}
									alt="edit"
									onClick={onEditWebsite}
								/>
							)}
						</p>
					</div>
				</div>
			</div>

			<Modal show={isShow} backdrop="static" onHide={handleClose} centered>
				<div className="common-popup">
					<Modal.Header closeButton>
						<Modal.Title>
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Contact</h3>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="name">Contact person*</label>
											<input
												type="text"
												autoComplete="off"
												id="name"
												name="name"
												onChange={onContactChange}
												value={selectedItem?.name || ''}
											/>
											{errors.nameError && <p className="error">{errors.nameError}</p>}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label htmlFor="designation">Designation</label>
											<input
												type="text"
												autoComplete="off"
												id="designation"
												name="designation"
												onChange={onContactChange}
												value={selectedItem?.designation || ''}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group mb-0">
											<label htmlFor="phone">Phone number*</label>
											<input
												type="number"
												id="phone"
												name="phone"
												onKeyPress={validateNumber}
												onChange={onContactChange}
												value={selectedItem?.phone || ''}
											/>
											{errors.phoneError && (
												<p className="error">{errors.phoneError}</p>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group mb-0">
											<label htmlFor="email">Email</label>
											<input
												type="email"
												name="email"
												id="email"
												onChange={onContactChange}
												value={selectedItem?.email || ''}
											/>
											{errors.emailError && (
												<p className="error">{errors.emailError}</p>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="common-popup-footer d-flex justify-content-between">
							<div className="delete-btn">
								<button
									className="button text size32"
									onClick={() => removeContactPerson(selectedItem.id)}
									disabled={viewType === 'add'}
								>
									Delete
								</button>
							</div>
							<div className="footer-buttons text-right">
								<button className="button outline size32" onClick={handleClose}>
									Cancel
								</button>
								<button
									disabled={isSubmitLoading}
									className="button size32 ml-2"
									onClick={() => onSave()}
								>
									Submit
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>

			<Modal show={showEditWeb} onHide={handleClose} centered backdrop="static">
				<div className="common-popup">
					<Modal.Header closeButton>
						<Modal.Title>
							{' '}
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Website</h3>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div>
							<div className="common-popup-body">
								<div className="container px-0">
									<div className="row">
										<div className="col-md-12">
											<div className="form-group mb-0">
												<label htmlFor="url">URL</label>
												<input
													type="text"
													autoComplete="off"
													id="url"
													placeholder="www.webaddress.com"
													value={webSite}
													onChange={(e) => setWebSite(e.target.value)}
												/>
												{errors.webUrlError && (
													<p className="error">{errors.webUrlError}</p>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="common-popup-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32" onClick={handleClose}>
									Cancel
								</button>
								<button
									disabled={isSubmitLoading}
									className="button size32 ml-2"
									onClick={onSubmitWeb}
								>
									Submit
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
};

export default Contact;
